import React from 'react';
import { Loader } from 'freemium-ui';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useGetContactForm } from 'shared/hooks';
import { Center } from 'shared/styles';
import {
  AccountInfoType,
  BreadcrumpDataType,
  ConfirmationType,
  UserType,
} from 'shared/types';
import Lists from './screens';
import ViewLists from './screens/view';

type ListsRoutesProps = {
  setBreadcrumpData?: (
    str: BreadcrumpDataType | React.SetStateAction<BreadcrumpDataType>,
  ) => void;
  setConfirmationData: (
    str: ConfirmationType | React.SetStateAction<ConfirmationType>,
  ) => void;
  actionTime?: string;
  accountInfo?: AccountInfoType;
  userInfo?: UserType;
  contactsCount: number;
  fetchContactCount: () => void;
};

const ListsRoutes = (props: ListsRoutesProps) => {
  const { t } = useTranslation();
  const {
    setBreadcrumpData,
    actionTime,
    setConfirmationData,
    accountInfo,
    userInfo,
    contactsCount,
    fetchContactCount,
  } = props;
  const { path } = useRouteMatch();
  const {
    data: contactForm = {},
    isLoading: isLoadingContactForm,
    isError: isContactFormError,
  } = useGetContactForm();

  if (isContactFormError)
    return <Center>{t('empty_state.message.network_error')}</Center>;

  return isLoadingContactForm ? (
    <Center>
      <Loader />
    </Center>
  ) : (
    <Switch>
      <Route exact path={path}>
        <Lists
          setConfirmationData={setConfirmationData}
          contactForm={contactForm}
          setBreadcrumpData={setBreadcrumpData}
          accountInfo={accountInfo}
          contactsCount={contactsCount}
          fetchContactCount={fetchContactCount}
        />
      </Route>
      <Route path={`${path}/:contactListId`}>
        <ViewLists
          contactForm={contactForm}
          setConfirmationData={setConfirmationData}
          actionTime={actionTime}
          setBreadcrumpData={setBreadcrumpData}
          accountInfo={accountInfo}
          userInfo={userInfo}
          contactsCount={contactsCount}
          fetchContactCount={fetchContactCount}
        />
      </Route>
    </Switch>
  );
};

export default ListsRoutes;
